import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Phone, Building2, MessageCircle, ChevronRight } from 'lucide-react';
import i18n from '../../i18n';
import '../../styles/components/footer.scss';
import { FacebookIcon, InstagramIcon, XIcon } from './icons';

export class FooterNew extends React.Component {
  handleWhatsAppClick = () => {
    window.open('https://api.whatsapp.com/send?phone=96892788822', '_blank');
  };

  render() {
    const currentYear = new Date().getFullYear();

    return (
      <React.Fragment>
        <footer className="modern-footer">
          <div className="modern-footer__container">
            {/* Company Info Section */}
            <div className="modern-footer__section modern-footer__section--main">
              <div className="modern-footer__logo">
                <img
                  src="/assets/images/logo-org.png"
                  alt="Mzadcom Logo"
                  className="modern-footer__logo-img"
                />
              </div>
              <p className="modern-footer__description">
                {i18n.t('about_mzadcom') ||
                  'Leading auction platform in Sultanate of Oman, providing transparent and secure bidding services.'}
              </p>
              <div className="modern-footer__social">
                <a
                  href="https://www.facebook.com/share/16gjCgFWas/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modern-footer__social-link"
                  aria-label="Facebook"
                >
                  <FacebookIcon />
                </a>
                <a
                  href="https://x.com/mzadcomom?s=11"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modern-footer__social-link"
                  aria-label="Twitter"
                >
                  <XIcon />
                </a>
                <a
                  href="https://www.instagram.com/mzadcomom"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="modern-footer__social-link"
                  aria-label="Instagram"
                >
                  <InstagramIcon />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="modern-footer__section">
              <h3 className="modern-footer__title">
                <Building2 size={20} />
                <span>{i18n.t('aboutus')}</span>
              </h3>
              <ul className="modern-footer__links">
                <li>
                  <Link to="/about" className="modern-footer__link">
                    <ChevronRight size={16} />
                    <span>{i18n.t('about_mzadcom')}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="modern-footer__link">
                    <ChevronRight size={16} />
                    <span>{i18n.t('contactus')}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/auc-calendar" className="modern-footer__link">
                    <ChevronRight size={16} />
                    <span>{i18n.t('auction_calendar')}</span>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="modern-footer__section">
              <h3 className="modern-footer__title">
                <MapPin size={20} />
                <span>{i18n.t('head_office')}</span>
              </h3>
              <div className="modern-footer__contact">
                <div className="modern-footer__contact-item">
                  <MapPin size={18} className="modern-footer__contact-icon" />
                  <div className="modern-footer__contact-text">
                    <p>{i18n.t('office_address_map')}</p>
                  </div>
                </div>
                <a
                  href="mailto:info@mzadcom.om"
                  className="modern-footer__contact-item modern-footer__contact-item--link"
                >
                  <Mail size={18} className="modern-footer__contact-icon" />
                  <span>info@mzadcom.om</span>
                </a>
                <a
                  href="tel:+96892788822"
                  className="modern-footer__contact-item modern-footer__contact-item--link"
                >
                  <Phone size={18} className="modern-footer__contact-icon" />
                  <span>
                    {i18n.t('management')}{' '}
                    <span dir="ltr" style={{ unicodeBidi: 'embed' }}>
                      (+968 92 788 822)
                    </span>
                  </span>
                </a>
                <a
                  href="tel:+96894370339"
                  className="modern-footer__contact-item modern-footer__contact-item--link"
                >
                  <Phone size={18} className="modern-footer__contact-icon" />
                  <span>
                    {i18n.t('technical_support')}{' '}
                    <span dir="ltr" style={{ unicodeBidi: 'embed' }}>
                      (+968 94 370 339)
                    </span>
                  </span>
                </a>
                <a
                  href="tel:+96892970111"
                  className="modern-footer__contact-item modern-footer__contact-item--link"
                >
                  <Phone size={18} className="modern-footer__contact-icon" />
                  <span>
                    {i18n.t('operations')}{' '}
                    <span dir="ltr" style={{ unicodeBidi: 'embed' }}>
                      (+968 92 970 111)
                    </span>
                  </span>
                </a>
              </div>
            </div>

            {/* Map Section */}
            <div className="modern-footer__section modern-footer__section--map">
              <h3 className="modern-footer__title">
                <MapPin size={20} />
                <span>{i18n.t('address')}</span>
              </h3>
              <div className="modern-footer__map">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.7917425383675!2d58.40742567510952!3d23.575921978789875!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff26ceace8cd%3A0x10a79b68a6eb0493!2sMazadcom%20Smart%20Auction%20Solution%20LLC!5e0!3m2!1sen!2som!4v1759736341678!5m2!1sen!2som"
                  className="modern-footer__map-iframe"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Mzadcom Office Location"
                ></iframe>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="modern-footer__bottom">
            <div className="modern-footer__container">
              <p className="modern-footer__copyright">
                © {currentYear} {i18n.t('mzadcom_rights')}
              </p>
              <div className="modern-footer__bottom-links">
                <Link to="/privacy-policy" className="modern-footer__bottom-link">
                  {i18n.t('privacy_policy')}
                </Link>
                <span className="modern-footer__separator">|</span>
                <Link to="/terms-of-service" className="modern-footer__bottom-link">
                  {i18n.t('terms_of_service')}
                </Link>
              </div>
            </div>
          </div>
        </footer>

        {/* WhatsApp Floating Button */}
        <button
          className="modern-footer__whatsapp"
          onClick={this.handleWhatsAppClick}
          aria-label={i18n.t('messaging') || 'Contact via WhatsApp'}
        >
          <MessageCircle size={28} />
        </button>
      </React.Fragment>
    );
  }
}
